import { render, staticRenderFns } from "./navtabs.vue?vue&type=template&id=0eb7b36d&"
import script from "./navtabs.vue?vue&type=script&lang=js&"
export * from "./navtabs.vue?vue&type=script&lang=js&"
import style0 from "./navtabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports